import Pulse from "./Pulse.presenter";

export default Pulse;
